module.exports = __webpack_public_path__ + "assets/68f76a7728babcdcf6a1d66b6e2b75b4.png";